import DOM from '@/scripts/old/modules/jqueryDOM';

function ContentPopup() {
  DOM.$document.on('click', '.js-content-popup__close', function close() {
    const $wrap = $(this).closest('.js-content-popup');
    $wrap.animate({
      opacity: 0,
    }, 300, () => {
      $wrap.remove();
    });
  });
}

export default new ContentPopup();
